import { Button } from '@rocketmakers/armstrong';
import * as React from 'react';
import { BackButton } from '../../../components/buttons/back-button';
import { useRoutePaths } from '../../../../../shared/context/paths';
import { routePaths } from '../../../routes';

export const FirmwareUpdatedView: React.FunctionComponent = () => {
  const { push } = useRoutePaths();

  const handleContinue = () => push(routePaths.verify.peripheral.check);

  return (
    <>
      <div>
        <BackButton />
        <h1>
          Verify <span className="color-primary">BEE Successfully Updated</span>
        </h1>

        <div>
          <p>The firmware has been successfully updated. Press 'next' below to continue.</p>
        </div>

        <div className="row">
          <Button data-qa="continue-button" className="continue-button btn-full btn-large" onClick={handleContinue}>
            Continue
          </Button>
        </div>
      </div>
    </>
  );
};
